import React from 'react';
// Icons
import { IoIosCloseCircleOutline } from 'react-icons/io';

function ContactFormItem({ form, handleDelete }) {
  return (
    <article
      className="grid grid-cols-rev bg-colour1 border px-4 py-4 h-fit rounded shadow"
      aria-label={`Contact form submission from ${form.firstName} ${form.lastName}`}
      itemScope
      itemType="https://schema.org/ContactPoint"
    >
      {/* Content Section */}
      <section aria-labelledby={`contact-heading-${form.id}`}>
        <h2 id={`contact-heading-${form.id}`} className="sr-only">
          Contact Form Submission Details
        </h2>

        <p>
          <strong>Name:</strong>{' '}
          <span itemProp="name">
            {form.firstName} {form.lastName}
          </span>
        </p>

        <p>
          <strong>Email:</strong>{' '}
          <a
            href={`mailto:${form.email}`}
            aria-label={`Email ${form.firstName} ${form.lastName}`}
            title={`Send an email to ${form.email}`}
            itemProp="email"
          >
            {form.email}
          </a>
        </p>

        <p>
          <strong>Phone:</strong>{' '}
          <a
            href={`tel:${form.phoneNumber}`}
            aria-label={`Call ${form.firstName} ${form.lastName}`}
            title={`Call ${form.phoneNumber}`}
            itemProp="telephone"
          >
            {form.phoneNumber}
          </a>
        </p>

        <p>
          <strong>Location:</strong>{' '}
          <span itemProp="areaServed">{form.location}</span>
        </p>

        <p>
          <strong>Business:</strong>{' '}
          <span itemProp="organization">{form.businessName}</span>
        </p>

        <p>
          <strong>Message:</strong>{' '}
          <span itemProp="description">{form.message}</span>
        </p>

        <p className="text-sm text-colour7">
          <strong>Submitted:</strong>{' '}
          <time
            dateTime={new Date(form.createdAt).toISOString()}
            itemProp="contactOption"
          >
            {new Date(form.createdAt).toLocaleString()}
          </time>
        </p>
      </section>

      {/* Delete Button */}
      <section className="flex justify-end items-start">
        <button
          onClick={() => handleDelete(form.id)}
          className="text-red-600 hover:text-red-800"
          title={`Delete submission from ${form.firstName} ${form.lastName}`}
          aria-label={`Delete contact form from ${form.firstName} ${form.lastName}`}
        >
          <IoIosCloseCircleOutline size={35} aria-hidden="true" />
        </button>
      </section>
    </article>
  );
}

export default ContactFormItem;
